module.exports = "https://static.wmbcdn.com/uniweb/images/a62a450551df93ac6453c7612ea85521.svg";